module.exports = __webpack_public_path__ + "img/03.06bde2a8.png";